module.exports = __webpack_public_path__ + "assets/img/059b51372c7652d7c524fe8366387e7b.png";